<template>
	<v-card>
		<div class="d-block align-center justify-center" v-if="form">
			<v-text-field
				class="d-inline-block mr-1"
				:error-messages="errors.nickname"
				type="text"
				label="昵称"
				v-model="form.nickname"
				id="nickname"
				style="width: 10rem"
			/>
			<v-text-field
				class="d-inline-block mr-1"
				type="text"
				label="电子邮箱"
				v-model="form.email"
				id="email"
				style="width: 20rem"
				:error-messages="errors.email"
			/>
			<v-text-field
				class="d-inline-block mr-1"
				type="text"
				label="手机号码"
				v-model="form.mobile"
				id="mobile"
				style="width: 10rem"
				:hint="form.mobilelocation"
				persistent-hint
				:error-messages="errors.mobile"
			></v-text-field>
		</div>
		<div class="mb-2">
			<v-select
				class="d-inline-block mr-1"
				style="width: 8rem"
				name="status"
				v-model="form.status"
				:items="refs['UserStatus']"
				:error-messages="errors.status"
			></v-select>
			<v-text-field
				label="注册时间"
				class="d-inline-block mr-1"
				style="width: 16rem"
				:value="form.registerTime"
				readonly
			></v-text-field>
			<v-text-field
				label="注册IP"
				class="d-inline-block mr-1"
				style="width: 16rem"
				:value="`${form.registerIp}`"
				:hint="form.ipLocation"
				persistent-hint
				readonly
			></v-text-field>
		</div>

		<slot name="actions" v-bind="{ object: form }"></slot>
	</v-card>
</template>

<script>
import { clone } from 'lodash-es'

export default {
	name: 'UserForm',
	props: {
		value: { type: Object, default: null },
		errors: { type: Object, default: () => ({}) }
	},
	data() {
		return {
			form: {},
			refs: {}
		}
	},
	watch: {
		value(nv) {
			this.form = clone(nv)
		}
	},
	methods: {},
	computed: {},
	mounted() {
		if (this.value) this.form = clone(this.value)
		else this.form = {}
		this.$api.common.meta('user', 'UserStatus,UserType', (r) => {
			this.refs = r
		})
	},
	components: {}
}
</script>
<style scoped></style>
